import { nanoId } from '@/helpers'
import Vue from 'vue'

const expense = () => {
  return {
    officeId: '',
    invoiceAmount: 0
  }
}

export const SET_OFFICEID = (state, { key, value }) => {
  state._[key].officeId = value
}

export const SET_INVOICEAMOUNT = (state, { key, value }) => {
  state._[key].invoiceAmount = value
}

export const ADD = (state, payload) => {
  let key = nanoId(8)
  state.list.push(key)
  if (!payload) payload = expense()
  Vue.set(state._, key, Object.assign({}, payload))
}

export const DELETE = (state, key) => {
  state.list = state.list.filter(k => k !== key)
  delete state._[key]
}
